/* eslint-disable max-len */
// Dependencies
import React from 'react'
import {connect} from 'react-redux'
import SyntaxHighlighter from 'react-syntax-highlighter'
import {a11yDark} from 'react-syntax-highlighter/dist/esm/styles/hljs';
import {diffChars} from 'diff'

// import Helpers from '../Helpers.js'
import {storePayload} from '../actions/storePayload'

// Images

// Styles
import '@lazarusai/forms-ui-components/dist/index.css'
import stylesCodeCompare from '../styles/CodeCompare.module.css'
import {Icon} from '@lazarusai/forms-ui-components'
// import {Icon} from '@lazarusai/forms-ui-components'

// Components


function CodeCompare({
  leftSide = {},
  rightSide = {},
  ...props
}) {
  function cleanCode(code) {
    return code?.includes('\\n') ? code.replaceAll('\\n', '\n') : code
  }

  return (
    <div
      className={stylesCodeCompare['code-compare']}
    >
      {[leftSide, rightSide].map((sideObj, sIndex) => {
        const title = sideObj?.title || (sIndex ? 'After': 'Before')
        const description = sideObj?.description
        const codeInter = sideObj?.code || ''
        const codeCleaned = cleanCode(codeInter)
        const diffs = sIndex === 0 ? diffChars(cleanCode(rightSide?.code || ''), codeCleaned) : diffChars(cleanCode(leftSide?.code || ''), codeCleaned)
        const infoIcon = sideObj?.infoIcon
        const language = sideObj?.codeLanguage || 'python'
        const iconColorClass = infoIcon.includes('alert') ? 'alert-icon' : 'good-icon'
        const addedLines = []
        const removedLines = []
        let lineCount = 0
        for (let dIndex = 0; dIndex < diffs.length; dIndex++) {
          const diffObj = diffs[dIndex]
          const numLines = (diffObj?.value?.match(/\n/g) || []).length
          if (diffObj?.value !== '\n' && diffObj?.value?.replaceAll(' ', '')?.length > 0) {
            if (diffObj?.added) {
              for (let cIndex = 0; cIndex <= numLines; cIndex++) {
                addedLines.push(lineCount + cIndex)
              }
            } else if (diffObj?.removed) {
              for (let cIndex = 0; cIndex <= numLines; cIndex++) {
                removedLines.push(lineCount + cIndex)
              }
            }
          }
          if (diffObj?.value?.includes('\n')) {
            lineCount = lineCount + numLines
          }
        }
        return (
          <div
            key={`${sIndex}-side`}
            className={stylesCodeCompare['code-compare-column']}
          >
            <div
              className={stylesCodeCompare['code-compare-column-title']}
            >
              {title}
            </div>
            <div
              className={`${stylesCodeCompare['code-compare-column-info']} ${stylesCodeCompare[iconColorClass]} ${!description ? stylesCodeCompare['hide-desc'] : ''}`}
            >
              <Icon
                icon={infoIcon}
              />
              <div>
                {description}
              </div>
            </div>
            <div
              className={stylesCodeCompare['code-compare-column-code']}
            >
              <SyntaxHighlighter
                language={language}
                style={a11yDark}
                showLineNumbers={true}
                wrapLines={true}
                lineProps={(lineNumber) => {
                  const style = {display: 'block'}
                  if (addedLines.includes(lineNumber)) {
                    style.backgroundColor = '#b3e87d60'
                  } else if (removedLines.includes(lineNumber)) {
                    style.backgroundColor = '#ff808060'
                  }
                  return {style}
                }}
              >
                {codeCleaned}
              </SyntaxHighlighter>
            </div>
          </div>
        )
      })}
    </div>
  )
}

const mapStateToProps = (state, ownProps) => ({
  theme: state.userReducer.theme,
  cookies: ownProps.cookies,
  storage: state.firebaseReducer.storage,
  database: state.firebaseReducer.database,
  firestore: state.firebaseReducer.firestore,
  userMessage: state.userReducer.userMessage,
  notificationType: state.userReducer.notificationType,
  notificationIcon: state.userReducer.notificationIcon,
  lang: state.userReducer.lang,
  isSignedIn: state.userReducer.isSignedIn,
  isFirebaseSignedIn: state.userReducer.isFirebaseSignedIn,
  isMFANeeded: state.userReducer.isMFANeeded,
  mfaError: state.userReducer.mfaError,
  user: state.userReducer.user,
  currentTasks: state.userReducer.currentTasks,
  taskId: state.userReducer.taskId,
})

export default connect(
    mapStateToProps,
    {storePayload},
)(CodeCompare)
